<script setup lang="ts">
import { ref } from "vue";
import { mapState } from "../../context/context";
import Pop from "./Pop.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Pop },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    tel: string;
  }>(),
  {}
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const mappedState = mapState([
  "color.foregroundPattern",
  "color.foregroundBorderPattern",
  "color.fontPattern",
  "color.fontTertiaryPattern"
]);

const el = ref();

function open() {
  el.value?.open();
}
function close() {
  el.value?.close();
}

defineExpose({ open, close });
</script>

<template>
  <Pop
    ref="el"
    directionFrom="bottom"
    :closeWhenClickOverlay="false"
    @open="() => emits('open')"
    @close="() => emits('close')"
  >
    <div
      class="pop-tel"
      :style="{
        backgroundColor: `${mappedState['color.foregroundPattern'].value}`,
        color: `${mappedState['color.fontPattern'].value}`
      }"
    >
      <div
        :style="{
          color: `${mappedState['color.fontTertiaryPattern'].value}`
        }"
      >
        {{ tel }}
      </div>
      <a
        class="pop-tel-call"
        :href="`tel:${tel}`"
        @click="close"
        :style="{
          borderTop: `1px solid ${mappedState['color.foregroundBorderPattern'].value}`,
          color: `${mappedState['color.fontPattern'].value}`,
          cursor: 'pointer'
        }"
      >
        呼叫
      </a>
      <div
        class="pop-tel-cancel"
        @click="close"
        :style="{
          borderTop: `1px solid ${mappedState['color.foregroundBorderPattern'].value}`,
          cursor: 'pointer'
        }"
      >
        取消
      </div>
    </div>
  </Pop>
</template>

<style scoped>
.pop-tel {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.pop-tel > div,
.pop-tel-call {
  display: block;
  height: 64px;
  line-height: 64px;
  font-size: 18px;
  text-align: center;
}
.pop-tel-call {
  font-weight: bold;
}
.pop-tel-call,
.pop-tel-call:link,
.pop-tel-call:visited,
.pop-tel-call:hover,
.pop-tel-call:active {
  /* 禁止长按链接与图片弹出菜单 */
  -webkit-touch-callout: none;
  text-decoration: none;
}
.pop-tel-call:focus {
  outline: none;
}
</style>
